var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar", { attrs: { title: _vm.$t("todo.title") } }),
      _c(
        "div",
        { staticClass: "text-md px-4 mt-3", on: { click: _vm.handleClick } },
        [_vm._v(_vm._s(_vm.$t("todo.completed1")))]
      ),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-3 gap-x-3 gap-y-3 px-4 mt-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6",
        },
        [
          _vm.todoInfo
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.registerSrc },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.register"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v("+100 " + _vm._s(_vm.$t("mine.points"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.zlStatus === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.zlSrc },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.completePersonalInfo"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v(
                      "+" +
                        _vm._s(_vm.todoInfo.zlPoint) +
                        " " +
                        _vm._s(_vm.$t("mine.points"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.shareStatus === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.shareSrc },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.share"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v(
                      "+" +
                        _vm._s(_vm.todoInfo.sharePoint) +
                        " " +
                        _vm._s(_vm.$t("mine.points"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.reviewTodoStatus === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.commentSrc },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.commentOnTheOrder"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v(
                      "+" +
                        _vm._s(_vm.todoInfo.commentPoint) +
                        " " +
                        _vm._s(_vm.$t("mine.points"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.inviteStatus === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.inviteSrc },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.recommend"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v(
                      "+" +
                        _vm._s(_vm.todoInfo.invitePoint) +
                        " " +
                        _vm._s(_vm.$t("mine.points"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.signStatus === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.signSrc },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.dailyAttendance"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v("+xxx " + _vm._s(_vm.$t("mine.points"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.order3Status === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.order3Src },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.complete3Orders"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v(
                      "+" +
                        _vm._s(_vm.todoInfo.order3Point) +
                        " " +
                        _vm._s(_vm.$t("mine.points"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.todoInfo.order6Status === 1
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-center bg-white rounded-xl w-full h-auto aspect-square px-1.5 border-2 border-[#FF9300]",
                },
                [
                  _c("img", {
                    staticClass: "w-12 h-12",
                    attrs: { src: _vm.order6Src },
                  }),
                  _c("div", { staticClass: "text-sm text-center mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("todo.complete6Orders"))),
                  ]),
                  _c("div", { staticClass: "text-sm" }, [
                    _vm._v(
                      "+" +
                        _vm._s(_vm.todoInfo.order6Point) +
                        " " +
                        _vm._s(_vm.$t("mine.points"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "text-md px-4 mt-8" }, [
        _vm._v(_vm._s(_vm.$t("todo.ongoing"))),
      ]),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-3 gap-x-3 gap-y-5 px-4 pb-4 mt-3 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6",
        },
        [
          _vm.todoInfo.zlStatus === 0
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.zlSrc },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.completePersonalInfo")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v(
                          _vm._s(_vm.todoInfo.zlPoint) +
                            " " +
                            _vm._s(_vm.$t("mine.points"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _c(
                    "van-button",
                    {
                      staticClass:
                        "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.goTo("/user-info")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("todo.toComplete")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.todoInfo.shareStatus === 0
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.shareSrc },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.share")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v(
                          _vm._s(_vm.todoInfo.sharePoint) +
                            " " +
                            _vm._s(_vm.$t("mine.points"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _c(
                    "van-button",
                    {
                      staticClass:
                        "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleShare },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("todo.contactService")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.todoInfo.reviewTodoStatus == 1 ||
          _vm.todoInfo.reviewTodoStatus == -1
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.commentSrc },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.commentOnTheOrder")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v(
                          _vm._s(_vm.todoInfo.commentPoint) +
                            " " +
                            _vm._s(_vm.$t("mine.points"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _vm.todoInfo.reviewTodoStatus == 1
                    ? _c(
                        "van-button",
                        {
                          staticClass:
                            "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.goTo("/my-reviews")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("todo.toComplete")) + " ")]
                      )
                    : _vm._e(),
                  _vm.todoInfo.reviewTodoStatus == -1
                    ? _c(
                        "van-button",
                        {
                          staticClass:
                            "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2",
                          attrs: { type: "primary" },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("todo.toComplete")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.todoInfo.inviteStatus === 0
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.inviteSrc },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.recommend")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v(
                          _vm._s(_vm.todoInfo.invitePoint) +
                            " " +
                            _vm._s(_vm.$t("mine.points"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _c(
                    "van-button",
                    {
                      staticClass:
                        "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                      attrs: {
                        type: "primary",
                        id: "invite",
                        "data-clipboard-text": _vm.inviteLink,
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("todo.copyLink")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.todoInfo.signStatus === 0
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.signSrc },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.dailyAttendance")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v("xxx " + _vm._s(_vm.$t("mine.points"))),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _c(
                    "van-button",
                    {
                      staticClass:
                        "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.goTo("/yoyo-coin-introduce")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("todo.goCollect")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.todoInfo.order3Status === 0
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.order3Src },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.complete3Orders")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v(
                          _vm._s(_vm.todoInfo.order3Point) +
                            " " +
                            _vm._s(_vm.$t("mine.points"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _c(
                    "van-button",
                    {
                      staticClass:
                        "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.goTo("/home")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("todo.toComplete")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.todoInfo.order6Status === 0
            ? _c(
                "div",
                { staticClass: "flex flex-col items-center justify-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center bg-gray-100 border-2 border-gray-200 rounded-xl w-full h-auto aspect-square px-1.5",
                    },
                    [
                      _c("img", {
                        staticClass: "w-12 h-12",
                        attrs: { src: _vm.order6Src },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-sm text-center mt-1 text-gray-500",
                        },
                        [_vm._v(_vm._s(_vm.$t("todo.complete6Orders")))]
                      ),
                      _c("div", { staticClass: "text-sm text-gray-500" }, [
                        _vm._v(
                          _vm._s(_vm.todoInfo.order6Point) +
                            " " +
                            _vm._s(_vm.$t("mine.points"))
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "text-sm invisible" }, [
                    _vm._v("占位"),
                  ]),
                  _c(
                    "van-button",
                    {
                      staticClass:
                        "mt-2 bg-gray-500 border-none w-26 h-8 rounded-md mb-2 bg-orange-500",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.goTo("/home")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("todo.toComplete")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }